export const GUIDE_NO_CREDITS_MESSAGE =
  'Seus créditos de IA acabaram. Recarregue em Meu Mentor -> Créditos para continuar conversando comigo.';
export const GUIDE_MIN_CREDITS_TO_CHAT = 20;

export function isGuideNoCreditsError(message: string) {
  const normalized = message
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  return (
    message === GUIDE_NO_CREDITS_MESSAGE ||
    normalized.includes('saldo insuficiente para consumir ia') ||
    normalized.includes('credito') ||
    normalized.includes('balance')
  );
}
